export const DATA_SECURITY_DASHBOARD = {
	ACCESS_PERMISSIONS: 'Assess Permissions: Review and adjust API user permissions as necessary in ',
	ACCESS_STATISTICS: 'Access Statistics',
	ADD_TO_MONITOR: 'Add to Arovy\'s Application Monitor to detect additional changes.',
	API_CALLS: 'API Calls',
	API_REQUESTS_LAST_24: 'Api Requests, Last 24 Hours',
	API_REQUESTS_TOOLTIP:
		// eslint-disable-next-line max-len
		'This is how many API calls have been made to your Salesforce instance in the last 24 hours, including today. For example, if you are viewing this on Monday at 2:30 PM, it will show you the calls made since Sunday at 2:30 PM.',
	API_VOLUME: 'API Volume',
	AUDIT_TRAIL: 'Audit Trail: Inspect the Salesforce audit trail for unauthorized access ',
	CALLS: 'Calls',
	DATA_SECURITY_POLICIES: 'Data Security Policies: Check compliance with organizational and legal standards.',
	DETECTED_APP_ACCESS_CHANGES: (app: string) =>
		// eslint-disable-next-line max-len
		`Arovy has detected application access changes for ${app}. Review the following suggested action plan for this detected app:`,
	EVENT_TYPE: 'Event',
	FIRST_DETECTED: 'First Detected',
	HIDE_DETECTED_APPS: 'Hide Detected',
	LAST_DETECTED: 'Last Detected',
	MONITORING_AND_INCIDENT_MANAGEMENT: 'Monitoring and Incident Management',
	MONITOR_APP: (app: string) => `Monitor ${app}`,
	PERMISSION_AND_ACCESS_CONTROL: 'Permission and Access Control',
	PLUS_MORE: (count: number): string => `+${count} more...`,
	REQUESTS: 'Requests',
	REVIEW_FIELD_LEVEL_SECURITY: 'Review Field-Level Security: Make sure sensitive fields are secured in ',
	SECURITY_AND_COMPLIANCE_REVIEW: 'Security and Compliance Review',
	SHOW_DETECTED_APPS: 'Show Detected',
	SUGGESTED_ACTION_PLAN_DETECTED_APP: 'Suggested Action Plan for Detected Application',
	SYSTEM_OVERVIEW: 'System Overview',
	THIRD_PARTY_ASSESSMENT: (app: string) => `Third-Party Assessment: Evaluate ${app}'s security measures.`,
	UPTIME_DAYS: (days: number): string => `Uptime, Last ${days}D`,
	UPTIME_MONITORS: 'Uptime Monitors',
	UPTIME_TOOLTIP: 'This overview shows the uptime for your tech stack. All uptime is aggregated in UTC zones.'
};
